import InformesListView from './InformesListView';

export default InformesListView;
